export const DEFAULT_ERROR_MESSAGE = 'Window failed to open'

export class PopupBlockedError extends Error {
  constructor (msg?: string) {
    super(msg || DEFAULT_ERROR_MESSAGE)
  }
}

export default PopupBlockedError
